import { render, staticRenderFns } from "./UnverifiedOrganization.vue?vue&type=template&id=290ff6c6&"
import script from "./UnverifiedOrganization.vue?vue&type=script&lang=ts&"
export * from "./UnverifiedOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports